export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-12.jpg'),
        title: 'DIGITAL REVOLUTION',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'THE DIGITAL REVOLUTION IS A COMPLETE PARADIGM SHIFT',
      description: `<p style="font-size:1.5rem">The world has changed in a profound way as a result of technological development, and being up to date with the latest technologies is key to success, regardless of your business domain.Just like the industrial revolution before it, the digital revolution is a complete paradigm shift. New technologies emerge at rapid pace and they establish themselves as very important steps on the path to success for  all companies. AI, IoT, blockchain, big data. All of these are not just keywords, but very important technologies that are integral to all aspects of our life, including the business landscape. Digital can change the way you run your company, the way predictions are made and the way products are sold, and making sure you're not let behind is crucial to remaining
relevant in today's digital global economy.
</p><p>MaesInfo can be a strong partner for your business' IT solutions. MaesInfo consultants have worked with myriad industries, including Fortune 500 companies to create custom, comprehensive solutions for companies.We offer our company's vast experience in software engineering to help you get ready for the digital age. Whether you need digitization of your services, assistance for your e-commerce business, software development or integration, MaesInfo has the experience to choose the proper IT solution for your company.</p>`
    },
    {
      title: 'MAESINFO OFFERS A WIDE RANGE OF SOLUTIONS, FOCUSING ON QUALITY AND COST EFFECTIVE IMPLEMENTATION:',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-12.jpg')+`)"></span>
      <span class="list">
      <i></i>develop your company's IT infrastructure<br/>
      <i></i>digitization of services<br/>
     <i></i>assist your business

      </span>`
    }
  ]
}
